import{b as o}from"./ninox-components-I2GBTDK4.js";var n={weight:o.normal,filling:1};export{n as a};
//# sourceMappingURL=ninox-components-PWW3TNA5.js.map